import CustomButton from 'components/Buttons/CustomButton'
import { getMetaContent } from 'helpers'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Card, CardText, Container } from 'reactstrap'
import ItemsDetail from './Details'
import ModalConfirm from './ModalConfirm'
import { getDataTrx } from './requestTransactionAction'
import { toggleModal } from './requestTransactionSlice'
import './style.scss'
import UserInfo from './UserInfo'

const ConfirmPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { detail } = useSelector((s) => s.reqTrxSell)

  let code = searchParams.get('code')
  let amount = searchParams.get('totalAmount')

  useEffect(() => {
    if (!code || !amount) navigate('/')
  }, [code, amount, navigate])

  useEffect(() => {
    if (code && amount) {
      dispatch(getDataTrx({ code, amount }))
    }
  }, [code, amount])

  return (
    <Container
      className="d-flex align-items-center justify-content-center w-100 h-100"
      style={{ minHeight: '100vh' }}
    >
      <ModalConfirm />
      <Card
        style={{ maxWidth: 480 }}
        className="px-2 mx-auto d-flex justify-content-center align-items-center w-100"
      >
        <img
          src={getMetaContent('og:image')}
          alt={`${getMetaContent('og:title')} logo`}
          className="text-center"
          style={{
            marginTop: 32,
            marginBottom: 24,
            width: '100%',
            maxWidth: '150px',
            height: 'auto',
          }}
        />

        <CardText tag="h4" className="mb-3">
          Transaksi sedang diproses
        </CardText>

        <div data-testid="order-seller-info">
          <UserInfo sellerDetail={detail?.sellerDetail} />
        </div>
        <ItemsDetail
          itemDetail={detail?.itemDetail}
          totalAmount={detail?.totalAmount}
        />
        <CustomButton
          testId="order-confirm-delivered-button"
          disabled={
            !detail?.escrowpaymentId && detail?.orderStatus !== 'ON_GOING'
          }
          onClick={() => dispatch(toggleModal())}
          className="mb-3"
          size="sm"
          block
          color="primary"
        >
          Konfirmasi Barang Sampai
        </CustomButton>
      </Card>
    </Container>
  )
}

export default ConfirmPage
